import { Button, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import ItemStatus from "../../../../../../common/components/item_status";

/**
 * GenerateObraAreaChecklistItemsColumnsDef
 */

type Props = {
  obraAreaChecklistStatus: number | null;
  onEnterChecklists: (idObraChecklistServico: number, openNewTab: boolean) => void;
  onActionDeletar: (idObraChecklistServico: number | null, openState: boolean) => void;
  onLiberarChecklists: (idObraChecklistServico: number | null, idChecklistServico: number | null, openState: boolean) => void;
};

export const GenerateObraAreaChecklistItemsColumnsDef = ({
  obraAreaChecklistStatus,
  onEnterChecklists,
  onActionDeletar,
  onLiberarChecklists,
}: Props): GridColDef[] => {
  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 0:
        return "Em aberto";
      case 1:
        return "Finalizada";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 0:
        return "yellow";
      case 1:
        return "red";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 0:
        return "Em aberto";
      case 1:
        return "Finalizada";
      default:
        return "?";
    }
  };

  const computeItemTipoTitle = (status: string) => {
    switch (status) {
      case 'C':
        return "Controlado";
      case 'E':
        return "Especializado";
      default:
        return "?";
    }
  };

  const computeItemTipoColor = (status: string) => {
    switch (status) {
      case 'C':
        return "yellow";
      case 'E':
        return "red";
      default:
        return "blue";
    }
  };

  const computeItemTipoDescription = (status: string) => {
    switch (status) {
      case 'C':
        return "Controlado";
      case 'E':
        return "Especializado";
      default:
        return "?";
    }
  };

  return [
    {
      field: "status",
      filterable: false,
      headerName: "Status",
      minWidth: 85,
      width: 85,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="extraSmall"
            title={computeItemStatusTitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={computeItemStatusDescription(params.value)}
          />
        </div>
      )
    },
    {
      field: "tipoServico",
      filterable: false,
      headerName: "Tipo",
      minWidth: 100,
      width: 100,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="extraSmall"
            title={computeItemTipoTitle(params.value)}
            color={computeItemTipoColor(params.value)}
            description={computeItemTipoDescription(params.value)}
          />
        </div>
      )
    },
    {
      field: "codigo",
      filterable: false,
      headerName: "Código",
      minWidth: 110,
      width: 110,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex items-center">
          {params.value}
        </div>
      ),
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex items-center">
          {params.value}
        </div>
      ),
    },
    {
      field: "revisao",
      filterable: false,
      headerName: "Revisão",
      minWidth: 70,
      width: 70,
      align: 'center',
      sortable: false,
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center">
          <div>{value}</div>
        </div>
      ),
    },
    {
      field: "itens",
      filterable: false,
      headerName: "Checklist",
      sortable: false,
      minWidth: 80,
      width: 80,
      valueGetter: (_, row) => { return row['idObraChecklistServico'] as number; },
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center">
            <Button
              onMouseDown={(e) => {
                if (e.button === 1) {
                  onEnterChecklists(value, true);
                } else {
                  onEnterChecklists(value, e.ctrlKey);
                }
                e.preventDefault();
              }}
              sx={{
                fontSize: 11,
                paddingX: '0.20rem',
                paddingY: 0,
                background: '#e6e6e6',
                borderLeft: '.2rem solid #8e44ad',
                borderRadius: 0,
                color: 'black',
                fontWeight: 'normal',
              }}>
              Itens
            </Button>
          </div>
        );
      },
    },
    {
      field: "total",
      filterable: false,
      headerName: "Total",
      minWidth: 70,
      width: 70,
      align: 'center',
      sortable: false,
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center">
          <div>{typeof value === 'number' && `${value}`}</div>
        </div>
      ),
    },
    {
      field: "ia",
      filterable: false,
      headerName: "I.A",
      minWidth: 70,
      width: 70,
      align: 'center',
      sortable: false,
      headerClassName: 'ia-header',
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center">
          <div>{typeof value === 'number' && `${(value * 100).toFixed(2)} %`}</div>
        </div>
      ),
    },
    {
      field: "ir",
      filterable: false,
      headerName: "I.R",
      minWidth: 70,
      width: 70,
      align: 'center',
      sortable: false,
      headerClassName: 'ir-header',
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center">
          <div>{typeof value === 'number' && `${(value * 100).toFixed(2)} %`}</div>
        </div>
      ),
    },
    {
      field: "ira",
      filterable: false,
      headerName: "I.RA",
      minWidth: 70,
      width: 70,
      align: 'center',
      sortable: false,
      headerClassName: 'ira-header',
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center">
          <div>{typeof value === 'number' && `${(value * 100).toFixed(2)} %`}</div>
        </div>
      ),
    },
    {
      field: "irep",
      filterable: false,
      headerName: "I.REP",
      minWidth: 70,
      width: 70,
      align: 'center',
      sortable: false,
      headerClassName: 'ix-header',
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center">
          <div>{typeof value === 'number' && `${(value * 100).toFixed(2)} %`}</div>
        </div>
      ),
    },
    {
      field: "liberarExecucao",
      filterable: false,
      headerName: "Liberada Execução?",
      minWidth: 85,
      width: 85,
      align: 'center',
      sortable: false,
      valueGetter: (_, row) => ({
        'idObraChecklistServico': row['idObraChecklistServico'],
        'idChecklistServico': row['idChecklistServico'],
        'liberarExecucao': row['liberarExecucao'],
      }),
      renderCell: ({ value: { idObraChecklistServico, idChecklistServico, liberarExecucao } }) => (
        <div className="w-full h-full flex justify-center items-center">
          <div className="w-[4rem]">
            <Button
              onMouseDown={(e) => {
                onLiberarChecklists(idObraChecklistServico, idChecklistServico, true);
                e.preventDefault();
              }}
              sx={{
                fontSize: 11,
                paddingX: '0.20rem',
                paddingY: 0,
                background: '#e6e6e6',
                borderLeft: '.2rem solid #8e44ad',
                borderRadius: 0,
                color: 'black',
                fontWeight: 'normal',
              }}>
              {liberarExecucao !== 0 ? 'Sim' : 'Não'}
            </Button>
          </div>
        </div>
      ),
    },
    {
      field: 'idObraChecklistServico',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 60,
      resizable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              disabled={obraAreaChecklistStatus === 1}
              onClick={() => onActionDeletar(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}